import { BaseEntity } from "yt-ng-framework";

export class EPrijemnicaStavkaDodatniAtribut extends BaseEntity{
    constructor(){
        super();
    }   
    EPrijemnicaStavkaID: number = null;
    Naziv: string=null;
    Vrednost: string=null;

    Deserialize(input:any){  
        super.Deserialize(input);
        this.ID=input.ID;
        this.EPrijemnicaStavkaID=input.EPrijemnicaStavkaID;
        this.Naziv=input.Naziv;
        this.Vrednost=input.Vrednost;
        return this;
    }

    Serialize(input:EPrijemnicaStavkaDodatniAtribut){
        return input;
    }
}